import { HeaderService } from 'src/app/core/services/header.service';
import { Component, OnInit, HostListener, Input } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { IdiomaService } from 'src/app/core/services/idioma.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  data: any;

  idiomaSelecionado;
  idiomas;

  isScrolled = false;

  logoSrc = 'assets/imagens/logo.png';

  isMobileNavOpen = false;
  isMobileSubMenuOpen = false;
  isMobileMenuIdiomaOpen = false;

  menuSubSelecionado = '0';

  constructor(
    private translate: TranslateService,
    private headerService: HeaderService,
    private idiomaService: IdiomaService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.carregarDados();
      this.idiomaSelecionado = this.idiomaService.getIdioma();
    });
  }

  ngOnInit() {
    this.carregarDados();

    this.idiomaSelecionado = this.idiomaService.getIdioma();
    this.idiomas = this.idiomaService.getIdiomas();
  }

  carregarDados() {
    this.translate.get('PRINCIPAL.HEADER')
      .subscribe(res => {
        this.data = res;
      });
  }

  alterarIdioma(idioma) {
    this.translate.use(idioma);
    this.isMobileNavOpen = true;
    this.clickMobileNav();
  }

  validaMenu(menu) {
    return menu === this.headerService.menuFlag;
  }

  validaSubMenu(menu, submenu) {
    return menu === this.headerService.menuFlag && submenu === this.headerService.submenuFlag;
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    if (window.pageYOffset || e.target.documentElement.scrollTop || e.target.body.scrollTop || 0 > 100) {
      if (!this.isScrolled) {
        this.isScrolled = true;
        // this.logoSrc = 'assets/imagens/logoInvertido.png';
      }
    } else {
      if (this.isScrolled) {
        this.isScrolled = false;
        // this.logoSrc = 'assets/imagens/logo.png';
      }
    }
  }

  clickMobileNav() {
    this.isMobileNavOpen = !this.isMobileNavOpen;

    if (this.headerService.submenuFlag == null) {
      this.headerService.submenuFlag = 0;
      this.isMobileSubMenuOpen = false;
    } else {
      this.menuSubSelecionado = this.headerService.menuFlag;
      this.isMobileSubMenuOpen = true;
    }
  }

  clickMobileMenu(menu) {
    this.isMobileSubMenuOpen = !this.isMobileSubMenuOpen;
    this.menuSubSelecionado = menu;
  }

  clickMobileMenuIdioma() {
    this.isMobileMenuIdiomaOpen = !this.isMobileMenuIdiomaOpen;
  }
}
